// Global stylesheet
import { createGlobalStyle } from 'styled-components'
import styledNormalize from 'styled-normalize'

import { baseColors, createColor } from './colors'
import { applyTextStyle } from './typography'

const GlobalStyle = createGlobalStyle`
  ${styledNormalize}

  html,
  body {
    width: 100%;
    height: 100%;
    color: black;
    font-family: 'Montserrat', sans-serif;
    ${applyTextStyle('body')}
  }

  * {
    box-sizing: border-box;
  }

  #root {
    width: 100%;
    height: 100%;
  }

  a {
    color: ${createColor(baseColors.primary)};
    text-decoration: none;
  }


`

export default GlobalStyle
